// CheckPage.jsx
import React, { useState, useEffect } from 'react';
import { FaSearch, FaDownload, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import DirectoryTable from '../../components/Directory/DirectoryTable';
import NewFailureModal from '../../components/Modals/NewFailureModal';
import SaveReportModal from '../../components/Modals/SaveReportModal';
import './CheckPage.css';

const CheckPage = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState(() => localStorage.getItem('checkQuery') || '');
  const [selectedCheckId, setSelectedCheckId] = useState(() => localStorage.getItem('selectedCheckId') || null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(0);           // ← добавлен счётчик перезагрузки


  useEffect(() => {
    localStorage.setItem('checkQuery', query);
  }, [query]);

  useEffect(() => {
    if (selectedCheckId !== null) {
      localStorage.setItem('selectedCheckId', selectedCheckId);
    }
  }, [selectedCheckId]);

  const downloadReport = ({ startDate, endDate }) => {
    console.log('Скачиваем отчет с', startDate, 'по', endDate);
    setShowReportModal(false);
  };

  const handleSearch = () => {
    console.log('Ищем:', query);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="check-page">
      <h1 className="page-title">Журнал поломок</h1>

      <div className="toolbar">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Поиск в таблице"
            value={query}
            onChange={e => setQuery(e.target.value)}
            onKeyDown={onKeyDown}
          />
          <button
            type="button"
            className="search-btn"
            onClick={handleSearch}
            title="Искать"
          >
            <FaSearch />
          </button>
        </div>

        <button className="icon-btn nn" title="Экспорт" onClick={() => setShowReportModal(true)}>
          <FaDownload />
        </button>
        <button className="primary-btn" onClick={() => setIsModalOpen(true)}>
          <FaPlus style={{ marginRight: 6 }} />
          Новая поломка
        </button>
      </div>

      <DirectoryTable
        query={query}
        selectedRowId={selectedCheckId}
        onRowSelect={row => {
          setSelectedCheckId(row.id);
          navigate(`/check/${row.id}`, { state: row });
        }}
        refreshFlag={refreshFlag}           // ← новое свойство
      />

      {isModalOpen && (
      <NewFailureModal
        onClose={() => setIsModalOpen(false)}
        onSave={() => {
          setRefreshFlag(f => f + 1);     // ↑ инкремент счётчика
          setIsModalOpen(false);
        }}
      />
    )}

      {showReportModal && (
        <SaveReportModal
          onClose={() => setShowReportModal(false)}
          onDownload={downloadReport}
        />
      )}
    </div>
  );
};

export default CheckPage;
